import { UnauthRoute } from '@/src/routes/routes.components'
import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'

const LoginScreenLazy = React.lazy(() => import('./screens/login.screen'))
const SsoLoginScreenLazy = React.lazy(() => import('./screens/sso/login.screen'))
const SsoFallbackScreenLazy = React.lazy(() => import('./screens/sso/fallback.screen'))
const ResetPasswordScreenLazy = React.lazy(() => import('./screens/reset_password.screen'))
const NewPasswordScreenLazy = React.lazy(() => import('./screens/new_password.screen'))
const InvitationScreenLazy = React.lazy(() => import('./screens/invitation.screen'))

export const sessionRoutePaths = {
  login: 'login',
  registration: 'registration',
  resetPassword: 'forgot-password',
  newPassword: 'password/reset',
  invitation: 'invitation',
  ssoLogin: 'login/sso/:companySlug',
  ssoFallback: 'login/sso/:companySlug/entra/fallback',
}

export const sessionRoutes: RouteObject[] = [
  {
    path: sessionRoutePaths.login,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div></div>}>
          <LoginScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
  {
    path: sessionRoutePaths.ssoLogin,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div></div>}>
          <SsoLoginScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
  {
    path: sessionRoutePaths.ssoFallback,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div></div>}>
          <SsoFallbackScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
  {
    path: sessionRoutePaths.resetPassword,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div></div>}>
          <ResetPasswordScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
  {
    path: sessionRoutePaths.newPassword,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div></div>}>
          <NewPasswordScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
  {
    path: sessionRoutePaths.invitation,
    element: (
      <UnauthRoute>
        <Suspense fallback={<div />}>
          <InvitationScreenLazy />
        </Suspense>
      </UnauthRoute>
    ),
  },
]
